/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import { Button, Grid, Row, Col } from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import Toolbar from 'loracoms/Toolbar';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import BoardList from './coms/BoardList';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  appState: React.PropTypes.object.isRequired,
  planState: React.PropTypes.object.isRequired,
};

class DashBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboards: [],
      showModal: false,
      deviceIds: [],
      appState: props.appState,
      planState: props.planState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillMount() {
    this.loadDashboards();
  }

  componentWillReceiveProps(nextProps) {
    const { appState, planState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (!_.isEqual(planState, this.props.planState)) {
      this.setState({ planState });
    }
  }

  loadDashboards() {
    const { appId } = this.props;
    callAPI({ endpoint: '/lora/dashboards', method: 'GET', query: { appeui: appId } })
      .then((res) => {
        this.setState({ dashboards: res.list });
      })
      .catch(() => {});
  }

  renderToolbar() {
    const { pushState, appId } = this.props;
    const { appState } = this.state;
    const { status, data: { name } = {} } = appState;
    const addButton = (
      <span>
        <Button
          bsStyle="aisz-success"
          onClick={() => pushState(`/application/${appId}/dashboard/add`)}
        >
          {this.intlMsg.msg('adddashboard')}{' '}<span className="halflings halflings-plus" />
        </Button>
      </span>
    );

    const breadcrumb = [
      {
        content: this.intlMsg.globalMsg('application.breadcrumb.application'),
        onClick: () => pushState('/application'),
      },
      {
        content: <Nvl status={status} val={name} />,
        active: true,
      }];
    return <Toolbar breadcrumb={breadcrumb} rightTools={[{ input: addButton }]} />;
  }

  render() {
    const { appId } = this.props;
    const { dashboards, appState, planState: { data = {}, status } } = this.state;
    if (status === 'pending' || !appState.data) {
      return <PageLoading />;
    }
    if (data.tier === 1) {
      return <PageNoPerm />;
    }

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              {this.renderToolbar()}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <BoardList appId={appId} boards={dashboards} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  appState: state.app.getApp,
  planState: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

DashBoard.propTypes = propTypes;

export default connect(mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(DashBoard,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/index.jsx